export type PromoverEstagiarioWizardStep = {
  id: number;
  title: string;
  shortTitle: string;
};

export const PROMOVER_ESTAGIARIO_WIZARD_STEPS: PromoverEstagiarioWizardStep[] = [
  { id: 1, title: 'Promover a estagi\u00e1rio', shortTitle: 'Promo\u00e7\u00e3o' },
  { id: 2, title: 'Cadastro do estagi\u00e1rio', shortTitle: 'Cadastro' },
  { id: 3, title: 'Lota\u00e7\u00e3o em local de atua\u00e7\u00e3o', shortTitle: 'Lota\u00e7\u00e3o' },
];

export type PromocaoDadosSalvos = {
  email: string;
  tipoEstagio: string;
  dataInicio: string;
  dataFim: string;
  fimSemana: boolean;
  nome: string;
};

export type PromoverEstagiarioWizardState = {
  pessoaId?: string;
  estagiarioId?: number;
  estagioId?: number;
  processoSeletivoId?: number;
  nomeEstagiario?: string;
  promocaoConcluida?: boolean;
  promocaoDados?: PromocaoDadosSalvos;
};
